import { createAction, props } from '@ngrx/store';
import {
  UserProfile,
  Department,
  Timezone,
} from '../models/user-profile.model';

// Load Profile
export const loadProfile = createAction('[Profile] Load Profile');
export const loadProfileSuccess = createAction(
  '[Profile] Load Profile Success',
  props<{ profile: UserProfile }>()
);
export const loadProfileFailure = createAction(
  '[Profile] Load Profile Failure',
  props<{ error: string }>()
);

// Update Profile
export const updateProfile = createAction(
  '[Profile] Update Profile',
  props<{ data: Partial<UserProfile> }>()
);
export const updateProfileSuccess = createAction(
  '[Profile] Update Profile Success',
  props<{ profile: UserProfile }>()
);
export const updateProfileFailure = createAction(
  '[Profile] Update Profile Failure',
  props<{ error: string }>()
);

// Load Departments
export const loadDepartments = createAction('[Profile] Load Departments');
export const loadDepartmentsSuccess = createAction(
  '[Profile] Load Departments Success',
  props<{ departments: Department[] }>()
);
export const loadDepartmentsFailure = createAction(
  '[Profile] Load Departments Failure',
  props<{ error: string }>()
);

// Load Timezones
export const loadTimezones = createAction('[Profile] Load Timezones');
export const loadTimezonesSuccess = createAction(
  '[Profile] Load Timezones Success',
  props<{ timezones: Timezone[] }>()
);
export const loadTimezonesFailure = createAction(
  '[Profile] Load Timezones Failure',
  props<{ error: string }>()
);

// Regenerate Token
export const regenerateToken = createAction('[Profile] Regenerate Token');
export const regenerateTokenSuccess = createAction(
  '[Profile] Regenerate Token Success',
  props<{ refreshToken: string }>()
);
export const regenerateTokenFailure = createAction(
  '[Profile] Regenerate Token Failure',
  props<{ error: string }>()
);

// Upload Photo
export const uploadPhoto = createAction(
  '[Profile] Upload Photo',
  props<{ file: File }>()
);
export const uploadPhotoSuccess = createAction(
  '[Profile] Upload Photo Success',
  props<{ photo: string }>()
);
export const uploadPhotoFailure = createAction(
  '[Profile] Upload Photo Failure',
  props<{ error: string }>()
);

// Delete Photo
export const deletePhoto = createAction('[Profile] Delete Photo');
export const deletePhotoSuccess = createAction('[Profile] Delete Photo Success');
export const deletePhotoFailure = createAction(
  '[Profile] Delete Photo Failure',
  props<{ error: string }>()
);

// Reset Update Status
export const resetUpdateStatus = createAction('[Profile] Reset Update Status');
